/* SELVYN v11: scroll and story layer.
   - [data-sv-reveal]: gets .is-in once it enters the screen.
   - [data-sv-progress]: gets --p from 0 (top of the block at the bottom of the screen) to 1 (bottom of the block at the top).
   - [data-sv-pin]: horizontal track pinned while the block scrolls past (desktop), native swipe on phones.
   - [data-sv-count]: counts from 001 to its target once, when seen.
   - [data-sv-chapters]: marks the chapter in view in the index.
   - [data-sv-bet]: the My Bet card preview, saved as an image on the visitor's own device.
   - [data-sv-anatomy]: pins on the product picture.
   Everything respects prefers-reduced-motion. No storage beyond the bet text, kept only in this browser. */
(function () {
  if (window.__svWow) return; window.__svWow = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  root.classList.add('sv-js');

  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 4 && getComputedStyle(pw).overflowY !== 'visible') return pw;
    return window;
  }

  /* Reveal ---------------------------------------------------------------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-sv-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Progress and pin ------------------------------------------------------- */
  var prog = [], pins = [], ticking = false;
  function measure() {
    ticking = false;
    var vh = window.innerHeight;
    prog.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var p = (vh - r.top) / (vh + r.height);
      el.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(4));
    });
    pins.forEach(function (el) {
      var track = el.querySelector('[data-sv-track]');
      if (!track) return;
      if (!el.classList.contains('is-pinned')) { track.style.transform = ''; return; }
      var r = el.getBoundingClientRect();
      var span = el.offsetHeight - vh;
      var p = span > 0 ? Math.max(0, Math.min(1, -r.top / span)) : 0;
      var view = track.parentElement, pad = parseFloat(getComputedStyle(view).paddingLeft) || 0;
      var dist = track.scrollWidth - view.clientWidth + pad;
      track.style.transform = 'translate3d(' + (-p * Math.max(0, dist)).toFixed(1) + 'px,0,0)';
      el.style.setProperty('--pin', p.toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
  function sizePins() {
    var desk = window.matchMedia('(min-width: 990px)').matches && !reduce;
    pins.forEach(function (el) {
      var track = el.querySelector('[data-sv-track]');
      if (!track) return;
      if (!desk) { el.classList.remove('is-pinned'); el.style.height = ''; track.style.transform = ''; return; }
      el.classList.add('is-pinned');
      var view = track.parentElement, pad = parseFloat(getComputedStyle(view).paddingLeft) || 0;
      var dist = track.scrollWidth - view.clientWidth + pad;
      el.style.height = (window.innerHeight + Math.max(0, dist)) + 'px';
    });
    measure();
  }
  var bound = null;
  function bindScroll() {
    var s = scroller();
    if (bound === s) return;
    if (bound) bound.removeEventListener('scroll', onScroll);
    s.addEventListener('scroll', onScroll, { passive: true });
    bound = s;
  }
  function initProgress(scope) {
    (scope || document).querySelectorAll('[data-sv-progress]').forEach(function (e) { if (prog.indexOf(e) < 0) prog.push(e); });
    (scope || document).querySelectorAll('[data-sv-pin]').forEach(function (e) { if (pins.indexOf(e) < 0) pins.push(e); });
    if (reduce) { prog.forEach(function (e) { e.style.setProperty('--p', '0.5'); }); }
    bindScroll(); sizePins();
  }
  window.addEventListener('resize', function () { bindScroll(); sizePins(); });
  window.addEventListener('load', function () { bindScroll(); sizePins(); });

  /* Count ------------------------------------------------------------------ */
  function pad3(n) { return ('00' + n).slice(-3); }
  function initCount(scope) {
    (scope || document).querySelectorAll('[data-sv-count]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '1');
      var to = parseInt(el.getAttribute('data-sv-count'), 10) || 100;
      var cells = el.closest('[data-sv-edition]') ? el.closest('[data-sv-edition]').querySelectorAll('[data-cell]') : [];
      function run() {
        if (reduce) { el.textContent = pad3(to); cells.forEach(function (c) { c.classList.add('is-lit'); }); return; }
        var t0 = null, dur = 2200;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3), n = Math.max(1, Math.round(e * to));
          el.textContent = pad3(n);
          for (var i = 0; i < cells.length && i < n; i++) cells[i].classList.add('is-lit');
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (!('IntersectionObserver' in window)) { run(); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* Chapters index --------------------------------------------------------- */
  function initChapters(scope) {
    (scope || document).querySelectorAll('[data-sv-chapters]:not([data-done])').forEach(function (wrap) {
      wrap.setAttribute('data-done', '1');
      var links = wrap.querySelectorAll('[data-sv-chapter-link]');
      var chs = wrap.querySelectorAll('[data-sv-chapter]');
      if (!('IntersectionObserver' in window) || !links.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.id;
          links.forEach(function (a) { var on = a.getAttribute('href') === '#' + id; a.classList.toggle('is-on', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      chs.forEach(function (c) { io.observe(c); });
      links.forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var t = document.querySelector(a.getAttribute('href'));
          if (!t) return; ev.preventDefault();
          t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  }

  /* My Bet card ------------------------------------------------------------ */
  function initBet(scope) {
    (scope || document).querySelectorAll('[data-sv-bet]:not([data-done])').forEach(function (box) {
      box.setAttribute('data-done', '1');
      var input = box.querySelector('[data-bet-input]');
      var nameIn = box.querySelector('[data-bet-name]');
      var cityIn = box.querySelector('[data-bet-city]');
      var out = box.querySelector('[data-bet-out]');
      var nameOut = box.querySelector('[data-bet-name-out]');
      var cityOut = box.querySelector('[data-bet-city-out]');
      var card = box.querySelector('[data-bet-card]');
      var save = box.querySelector('[data-bet-save]');
      var status = box.querySelector('[data-bet-status]');
      var ph = out ? out.getAttribute('data-placeholder') : '';
      var KEY = 'sv-my-bet';
      try { var saved = JSON.parse(localStorage.getItem(KEY) || 'null'); if (saved) { input.value = saved.b || ''; if (nameIn) nameIn.value = saved.n || ''; if (cityIn) cityIn.value = saved.c || ''; } } catch (e) {}
      function render() {
        var v = (input.value || '').trim();
        out.textContent = v || ph;
        out.classList.toggle('is-empty', !v);
        if (nameOut) nameOut.textContent = (nameIn && nameIn.value.trim()) || '';
        if (cityOut) cityOut.textContent = (cityIn && cityIn.value.trim()) || '';
        if (save) save.disabled = !v;
        try { localStorage.setItem(KEY, JSON.stringify({ b: input.value, n: nameIn ? nameIn.value : '', c: cityIn ? cityIn.value : '' })); } catch (e) {}
      }
      [input, nameIn, cityIn].forEach(function (i) { if (i) i.addEventListener('input', render); });
      render();

      if (card && !reduce && window.matchMedia('(hover: hover)').matches) {
        box.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          card.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
          card.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        });
        box.addEventListener('pointerleave', function () { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
      }

      function wrapLines(ctx, text, max) {
        var words = text.split(/\s+/), lines = [], cur = '';
        words.forEach(function (w) {
          while (ctx.measureText(w).width > max && w.length > 1) { var k = w.length - 1; while (k > 1 && ctx.measureText(w.slice(0, k)).width > max) k--; if (cur) { lines.push(cur); cur = ''; } lines.push(w.slice(0, k)); w = w.slice(k); }
          var t = cur ? cur + ' ' + w : w; if (ctx.measureText(t).width > max && cur) { lines.push(cur); cur = w; } else cur = t;
        });
        if (cur) lines.push(cur);
        return lines;
      }
      function draw() {
        var W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d');
        var ink = '#141211', bone = '#F2EFE9', smoke = '#6B655D', hair = '#B8B1A6';
        x.fillStyle = ink; x.fillRect(0, 0, W, H);
        var cw = 720, ch = 1018, cx = (W - cw) / 2, cy = 120;
        x.fillStyle = '#FBFAF7'; x.fillRect(cx, cy, cw, ch);
        x.fillStyle = ink; x.font = '500 20px Switzer, Helvetica, Arial, sans-serif'; x.textBaseline = 'alphabetic';
        if ('letterSpacing' in x) x.letterSpacing = '3px';
        x.fillText('MY BET', cx + 64, cy + 92);
        x.textAlign = 'right'; x.fillText('NO. ___ / 100', cx + cw - 64, cy + 92); x.textAlign = 'left';
        if ('letterSpacing' in x) x.letterSpacing = '0px';
        var top = cy + 230, gap = 92;
        x.strokeStyle = hair; x.lineWidth = 2;
        for (var i = 0; i < 4; i++) { x.beginPath(); x.moveTo(cx + 64, top + i * gap); x.lineTo(cx + cw - 64, top + i * gap); x.stroke(); }
        x.fillStyle = ink; x.font = 'italic 50px "Bodoni Moda", Didot, Georgia, serif';
        var lines = wrapLines(x, (input.value || '').trim(), cw - 140).slice(0, 4);
        lines.forEach(function (l, k) { x.fillText(l, cx + 70, top + k * gap - 16); });
        var ny = top + 3 * gap + 150;
        x.beginPath(); x.moveTo(cx + 64, ny); x.lineTo(cx + 64 + 270, ny); x.moveTo(cx + cw - 64 - 270, ny); x.lineTo(cx + cw - 64, ny); x.stroke();
        x.font = 'italic 34px "Bodoni Moda", Georgia, serif';
        x.fillText((nameIn && nameIn.value.trim()) || '', cx + 70, ny - 14);
        x.fillText((cityIn && cityIn.value.trim()) || '', cx + cw - 64 - 264, ny - 14);
        x.fillStyle = smoke; x.font = '500 16px Switzer, Helvetica, Arial, sans-serif';
        if ('letterSpacing' in x) x.letterSpacing = '2px';
        x.fillText('NAME', cx + 64, ny + 32); x.fillText('CITY', cx + cw - 64 - 270, ny + 32);
        x.fillStyle = ink; x.fillText('SIGNED, SELVYN', cx + 64, cy + ch - 64);
        x.textAlign = 'right'; x.fillText('@SELVYNCLOTHING', cx + cw - 64, cy + ch - 64); x.textAlign = 'left';
        if ('letterSpacing' in x) x.letterSpacing = '0px';
        x.fillStyle = bone; x.font = 'italic 46px "Bodoni Moda", Georgia, serif'; x.textAlign = 'center';
        x.fillText('Bet on yourself.', W / 2, H - 76);
        return c;
      }
      function download(blob) {
        var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'selvyn-my-bet.png';
        document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 800);
        if (status) { status.hidden = false; }
      }
      if (save) save.addEventListener('click', function () {
        if (!(input.value || '').trim()) return;
        var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        ready.then(function () {
          var c = draw();
          c.toBlob(function (blob) {
            if (!blob) return;
            var file = null;
            try { file = new File([blob], 'selvyn-my-bet.png', { type: 'image/png' }); } catch (e) {}
            if (file && navigator.canShare && navigator.canShare({ files: [file] }) && window.matchMedia('(hover: none)').matches) {
              navigator.share({ files: [file], title: 'My bet' }).catch(function (err) { if (!err || err.name !== 'AbortError') download(blob); });
              return;
            }
            download(blob);
          }, 'image/png');
        });
      });
    });
  }

  /* Anatomy pins ----------------------------------------------------------- */
  function initAnatomy(scope) {
    (scope || document).querySelectorAll('[data-sv-anatomy]:not([data-done])').forEach(function (box) {
      box.setAttribute('data-done', '1');
      var pins = box.querySelectorAll('[data-pin]');
      var rows = box.querySelectorAll('[data-row]');
      function set(i) {
        pins.forEach(function (p) { var on = p.getAttribute('data-pin') === String(i); p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        rows.forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-row') === String(i)); });
      }
      pins.forEach(function (p) {
        p.addEventListener('click', function () { set(p.classList.contains('is-on') ? -1 : p.getAttribute('data-pin')); });
        p.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) set(p.getAttribute('data-pin')); });
      });
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { set(r.getAttribute('data-row')); });
        r.addEventListener('focusin', function () { set(r.getAttribute('data-row')); });
      });
      box.addEventListener('mouseleave', function () { set(-1); });
      box.__svClose = function () { set(-1); };
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sv-anatomy]').forEach(function (b) { if (b.__svClose) b.__svClose(); });
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(function () {
      prog = prog.filter(function (e) { return document.contains(e); });
      pins = pins.filter(function (e) { return document.contains(e); });
    }, 0);
  });

  /* Quick add on shop cards ------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sv-quick]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var box = b.closest('.sv-card__quick'), msg = box && box.querySelector('[data-sv-quick-msg]');
    if (typeof window.svAddOne !== 'function') { window.location.href = (b.closest('.sv-cardwrap').querySelector('a') || {}).href || '/'; return; }
    b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    window.svAddOne(b.getAttribute('data-sv-quick')).then(function () {
      if (msg) { msg.textContent = 'Added, size ' + b.textContent.trim(); msg.hidden = false; }
    }).catch(function () {
      if (msg) { msg.textContent = 'Could not add. Open the product to try again.'; msg.hidden = false; }
    }).then(function () { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
  });

  function init(scope) { initReveal(scope); initProgress(scope); initCount(scope); initChapters(scope); initBet(scope); initAnatomy(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* v13 pay choice: show the number picker only for pay ahead (delegated, survives re-renders) */
document.addEventListener('change', function (e) {
  var root = e.target.closest && e.target.closest('[data-sv-pay]'); if (!root) return;
  var a = root.querySelector('[data-sv-pay-a]'), box = root.querySelector('[data-sv-pay-num]'); if (!a || !box) return;
  box.hidden = !a.checked; var sel = box.querySelector('select'); if (sel) sel.disabled = !a.checked;
});
